import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  chartCard: {
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,
    display: 'flex',
    flexDirection: 'column',
    gap: 32,

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: 16,
    },
  },

  chartLegend: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '24px 16px',
    margin: 0,
    padding: '0 0 0 8px',
    listStyle: 'none',

    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
  },

  chartLegendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },

  chartLegendMarker: {
    width: 32,
    height: 24,
    borderRadius: 50,
    flexShrink: 0,
  },
}), { name: 'RetirementCalculatorChartCard' });
